import { Modal } from 'antd';
import { PureComponent, ReactNode } from 'react';
import { ThunkDispatch } from 'redux-thunk';
import { Actions } from '../../store/actions';
import { GlobalState } from '../../store/reducers';
import { connect } from 'react-redux';
import { toggleLogoutModal } from '../../store/actions/session';
import { getIsLogoutModalVisible } from '../../store/selectors/session';
import { gotoLogout } from './NewHeaderComponent';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { track } from '../../tracking';

interface Props extends RouteComponentProps {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    isLogoutModalVisible?: boolean;
}

class LogoutModal extends PureComponent<Props> {
    closeMe = () => {
        const { dispatch } = this.props;
        dispatch(toggleLogoutModal());
    };

    gotoLogout = (clear: boolean) => {
        const { history } = this.props;
        const { closeMe } = this;
        gotoLogout(history, clear);
        closeMe();
        track('GO_TO_LOGOUT', { clear: String(clear) });
    };

    render(): ReactNode {
        const { isLogoutModalVisible } = this.props;
        const { closeMe, gotoLogout } = this;

        return (
            <Modal
                bodyStyle={{
                    padding: '0px',
                }}
                visible={isLogoutModalVisible}
                width={400}
                onCancel={closeMe}
                footer={null}
                closable={false}
                destroyOnClose
            >
                <div className="p-20 space-y-24">
                    <div className="flex items-center justify-between">
                        <p className="text-16 font-700">Are you sure you want to logout?</p>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 320 512"
                            className="cursor-pointer fill-neutral-5"
                            onClick={closeMe}
                        >
                            <path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path>
                        </svg>
                    </div>
                    <div className="grid grid-cols-2 space-x-8">
                        <button
                            className="px-9 py-5 rounded-4 border border-darwin-accent-bright-blue-800 text-13 font-700 text-darwin-accent-bright-blue-800 text-center"
                            onClick={() => gotoLogout(false)}
                        >
                            Logout & Keep Data
                        </button>
                        <button
                            className="px-10 py-6 rounded-4 bg-darwin-accent-bright-blue-800 text-13 font-700 text-white text-center"
                            onClick={() => gotoLogout(true)}
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default connect((state: GlobalState) => ({
    isLogoutModalVisible: getIsLogoutModalVisible(state),
}))(withRouter(LogoutModal));
